<ng-container *ngIf="view as v">
  <!-- Backdrop NO BLOQUEANTE por defecto (§20 T6.1): las 4 máscaras alrededor
       del hueco solo atenúan y dejan pasar el clic — el usuario puede seguir
       operando toda la pantalla, no solo el elemento resaltado. Únicamente los
       pasos con `blockOutsideInteraction` (los que viven dentro de un mat-menu,
       que cualquier clic al backdrop cerraría) capturan el clic exterior. En
       pasos centrados (sin ancla) el backdrop nunca bloquea. -->
  <ng-container *ngIf="layout?.spotlight as s; else fullBackdrop">
    <div
      class="gt-mask gt-mask--top"
      [class.gt-mask--through]="!blocksOutside"
      [style.height.px]="s.top"
    ></div>
    <div
      class="gt-mask gt-mask--bottom"
      [class.gt-mask--through]="!blocksOutside"
      [style.top.px]="s.top + s.height"
    ></div>
    <div
      class="gt-mask gt-mask--left"
      [class.gt-mask--through]="!blocksOutside"
      [style.top.px]="s.top"
      [style.width.px]="s.left"
      [style.height.px]="s.height"
    ></div>
    <div
      class="gt-mask gt-mask--right"
      [class.gt-mask--through]="!blocksOutside"
      [style.top.px]="s.top"
      [style.left.px]="s.left + s.width"
      [style.height.px]="s.height"
    ></div>
  </ng-container>
  <ng-template #fullBackdrop>
    <div class="gt-backdrop gt-backdrop--full"></div>
  </ng-template>

  <!-- Spotlight: recorte iluminado sobre el ancla (solo visual, click-through). -->
  <div
    *ngIf="layout?.spotlight as s"
    class="gt-spotlight"
    [style.top.px]="s.top"
    [style.left.px]="s.left"
    [style.width.px]="s.width"
    [style.height.px]="s.height"
  ></div>

  <!-- Tarjeta paso-a-paso -->
  <div
    class="gt-card"
    #gtCard
    *ngIf="layout as l"
    [class.gt-card--center]="l.placement === 'center'"
    [style.top.px]="l.card.top"
    [style.left.px]="l.card.left"
    role="dialog"
    aria-live="polite"
  >
    <div class="gt-card__head">
      <span class="gt-card__badge">{{ v.index + 1 }} / {{ v.total }}</span>
      <span class="gt-card__tutorial">{{ v.tutorial.title }}</span>
      <button
        type="button"
        class="gt-card__close"
        (click)="exit()"
        title="Salir (podrás retomarlo donde quedaste)"
        aria-label="Salir del tutorial"
      >
        &times;
      </button>
    </div>

    <h3 class="gt-card__title">{{ v.step.title }}</h3>
    <div class="gt-card__body" [innerHTML]="bodyHtml"></div>

    <!-- Gating SUAVE (§20 T3): el hint SUGIERE la acción real (que, si se hace,
         adelanta el paso sola) pero "Siguiente" sigue disponible — nadie tiene
         que borrar datos ni gastar créditos para poder avanzar. -->
    <div class="gt-card__confirm-hint" *ngIf="isAwaitingConfirm">
      <span class="gt-card__confirm-pulse" aria-hidden="true"></span>
      <span>
        {{ confirmHint }}
        <em class="gt-card__confirm-opt"
          >Es opcional: también puedes continuar con “{{ primaryLabel }}”.</em
        >
      </span>
    </div>

    <div class="gt-card__foot">
      <button
        type="button"
        class="gt-btn gt-btn--ghost"
        (click)="exit()"
        title="Podrás retomarlo donde quedaste desde el botón de ayuda"
      >
        Salir
      </button>
      <div class="gt-card__nav">
        <button
          type="button"
          class="gt-btn gt-btn--ghost"
          *ngIf="!isFirst"
          (click)="prev()"
        >
          Anterior
        </button>
        <button type="button" class="gt-btn gt-btn--primary" (click)="next()">
          {{ primaryLabel }}
        </button>
      </div>
    </div>

    <!-- Encadenado como acción SECUNDARIA (§20 T5): terminar un recorrido ya no
         arrastra al siguiente. El primario es "Finalizar"; seguir con el
         siguiente es una decisión aparte y explícita. -->
    <div class="gt-card__chain" *ngIf="chainOffer as chain">
      <button type="button" class="gt-btn gt-btn--soft" (click)="continueChain()">
        {{ chain.label }} ›
      </button>
    </div>

    <!-- La segunda salida (§20 T4): "Salir" pausa y deja el botón de retomar;
         esto descarta el tutorial de verdad. En su propia línea porque el pie ya
         va lleno a 340px. -->
    <div class="gt-card__dismiss">
      <button
        type="button"
        class="gt-link"
        (click)="dismissForever()"
        title="No volver a ofrecer este tutorial (puedes reactivarlo en tu perfil)"
      >
        No mostrar más
      </button>
    </div>
  </div>
</ng-container>

<!-- INVITACIÓN (§20 T1): reemplaza al auto-lanzamiento en la 1ª visita a un
     módulo. Píldora discreta abajo-centro (zona libre del lienzo) que NO tapa
     nada ni bloquea clics: el usuario decide si quiere el recorrido. "No,
     gracias" lo descarta para siempre; la × solo lo aplaza. Se esconde mientras
     haya un modal abierto o un tour activo. -->
<div
  class="gt-invite"
  *ngIf="!view && !hayModalAbierto && invitation as inv"
  role="status"
>
  <span class="gt-invite__icon" aria-hidden="true">?</span>
  <span class="gt-invite__text">
    <b>{{ inv.title }}</b>
    <small>Recorrido guiado · {{ inv.steps.length }} pasos · ~{{ invitationMinutes }} min</small>
  </span>
  <button
    type="button"
    class="gt-btn gt-btn--primary gt-btn--sm"
    (click)="acceptInvitation()"
  >
    Ver recorrido
  </button>
  <button
    type="button"
    class="gt-link gt-link--on-dark"
    (click)="declineInvitation()"
    title="No volver a ofrecerlo (puedes reactivarlo en tu perfil)"
  >
    No, gracias
  </button>
  <button
    type="button"
    class="gt-invite__close"
    (click)="closeInvitation()"
    title="Más tarde"
    aria-label="Cerrar"
  >
    &times;
  </button>
</div>

<!-- BOTÓN DE RETOMAR (§19, discretizado en §20 T4): aparece cuando hay un
     tutorial pausado relevante para la pantalla actual y no hay tour activo. Es
     un botón mínimo "?" sin pulso; el rótulo se despliega al pasar el mouse. Va
     a la ALTURA DEL TOOLBAR del grafo, pegado al borde derecho: `top`/`right`
     los calcula el componente midiendo el toolbar real (el CSS no puede: el
     toolbar es `absolute` dentro del lienzo). Se esconde mientras haya un modal
     abierto (mejoras_8 T5): su z-index está por encima del
     `.cdk-overlay-container` y tapaba los diálogos. -->
<button
  *ngIf="!view && !hayModalAbierto && resumable as r"
  type="button"
  class="gt-resume-fab"
  [style.top.px]="fabTop"
  [style.right.px]="fabRight"
  (click)="resumeTutorial()"
  [attr.title]="resumeTooltip"
  [attr.aria-label]="'Retomar tutorial: ' + r.tutorial.title"
>
  <span class="gt-resume-fab__icon" aria-hidden="true">?</span>
  <span class="gt-resume-fab__label">Retomar tutorial</span>
</button>
